import 'twin.macro'
import './../../../node_modules/bvi/dist/css/bvi.min.css'

import FFLogo from 'assets/icons/FreedomLogo'
import PhoneIcon from 'assets/icons/PhoneIcon'
import WhatsappIcon from 'assets/icons/WhatsApp'
import ContactItem from 'components/UI/contact/contacat-item'
import LangToggle from 'components/UI/lang-toggle'
import { MenuToggle } from 'components/UI/menu-toggle/menu-toggle.jsx'
import { motion, useCycle } from 'framer-motion'
import { useDeviceInfo } from 'hooks/useDeviceInfo'
import i18n from 'i18n/config'
import React, { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { isAuthSelector } from 'redux/store/slices/auth-slice'
import tw from 'twin.macro'
import { pathnames } from 'utils/steps'

import MobileHeader from './mobile-header'
import SignInButton from './sign-in-container'
import ThemeToggle from './theme-toggle'

const languages = [
  { title: 'Қаз', value: 'kk' },
  { title: 'Рус', value: 'ru' },
  { title: 'Eng', value: 'en' }
]
function Header() {
  const { isMobile } = useDeviceInfo()
  const { pathname } = useLocation()
  const isActivationFlow = useMemo(
    () =>
      pathname === pathnames['activation-enter-phone'] ||
      pathname === pathnames['activation-loading'] ||
      pathname === pathnames['otp-verify'] ||
      pathname === pathnames['idn-enter'] ||
      pathname === pathnames['error'],
    [pathname]
  )

  return (
    <div tw='border border-grey border-l-0 border-t-0 border-r-0'>
      {isMobile ? (
        <MobileHeader />
      ) : (
        <div tw='mx-auto flex items-center justify-between py-2 max-w-landing lg:px-0 relative z-30'>
          <a href='https://bankffin.kz/ru'>
            <FFLogo />
          </a>
          <div tw='flex gap-6 mr-2 items-center text-[#5C5C5C]'>
            {/*<ContactItem link='https://wa.me/77760595595' icon={<WhatsappIcon />} label='+7 776 1 595 595' />*/}
            <ContactItem link='tel:595' icon={<PhoneIcon />} label='595' />
            <LangToggle />
            <ThemeToggle />
            {!isActivationFlow && <SignInButton />}
          </div>
        </div>
      )}
    </div>
  )
}

export default Header
